module.exports = __webpack_public_path__ + "img/极东.a8516e5e.png";